'use strict';

import Recommendations from '@jsclasses/recommendations';

// Selectors
const selector = {
  wrapper: {
    recommendations: '.js-recommendations'
  }
};

// Elements
const element = {
  wrapper: {
    recommendations:
      document.querySelector(selector.wrapper.recommendations) || null
  }
};

// Functions
const initRecommendations = () => {
  if (element.wrapper.recommendations) {
    new Recommendations({
      wrapper: element.wrapper.recommendations,
      showPrice: true,
      maxVisibleItems: 4
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  initRecommendations();
});
